// Tunable knobs for the Feature widget.
import { SENTIMENT_SOURCE } from "../sentiment";

export const CONFIG = {
  // Per-feature sentiment source — shared dashboard-wide (see ../sentiment
  // SENTIMENT_SOURCE); flip it there to switch both this widget and the Sentiment
  // widget together.
  sentimentSource: SENTIMENT_SOURCE,

  // Max feature rows to render.
  maxFeatures: 12,
};
